import React, { FC, ReactElement, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Loader from '../Loader/Loader';
import { useAuth } from 'oidc-react';

const AuthRedirect: FC<RouteComponentProps> = (props: RouteComponentProps): ReactElement => {
  const { userData, isLoading } = useAuth();

  const redirect = (): void => {
    const url = sessionStorage.getItem('redirectURL');

    props.history.replace(url || '/');
  };

  useEffect(() => {
    if (!isLoading && userData) {
      redirect();
    }
  });

  return <Loader />;
};

export default AuthRedirect;
